import request from "@/plugins/axios/request";

export function apiSearch(keyWord) {
    return request({
        url: "/apidoc/search",
        method: "get",
        params: {
            keyWord
        }
    });
}
export function apiType() {
    return request({
        url: "/apidoc/api/category",
        method: "get"
    });
}
export function apiTypesh(id) {
    return request({
        url: "/apidoc/api/category/" + id,
        method: "get"
    });
}

export function apiNavDetails() {
    return request({
        url: "/apidoc/api/categoryAll",
        method: "get"
    });
}

export function apiDetails(apiId) {
    return request({
        url: `/apidoc/${apiId}`,
        // url: "/api/doc?id=" + apiId,
        method: "get"
    });
}

export function myApplication(appInfo) {
    return request({
        url: "/page/app/search",
        method: "post",
        data: appInfo
    });
}

export function addApplication(appInfo) {
    return request({
        url: "/page/app/save",
        method: "post",
        data: appInfo
    });
}

export function apiByApp(appInfo) {
    return request({
        url: "/page/api/byApp",
        method: "post",
        data: appInfo
    });
}

export function addapi(accObject) {
    return request({
        url: "/page/api/save",
        method: "post",
        data: accObject
    });
}

export function querykey(appId) {
    return request({
        url: `/page/app/get/${appId}`,
        method: "get"
    });
}

export function updateCallBackInfo(updateInfo) {
    return request({
        url: "/page/app/update/callbackUrl",
        method: "put",
        data: updateInfo
    });
}
export function getSelect(id) {
    return request({
        url: "/page/" + id,
        method: "get"
    });
}

export function myApplications(id, appInfo) {
    return request({
        url: "/" + id,
        method: "post",
        data: appInfo
    });
}

export function requestPhone(phone) {
    return request({
        url: `/page/mobileVaildCode/${phone}`,
        method: "get"
    });
}

export function requestSecretkey(params) {
    return request({
        url: "/page/app/get/secretkey",
        method: "post",
        data: params
    });
}

export function deleteApiByAppId(ids) {
    return request({
        url: "/page/api/nexus",
        method: "post",
        data: ids
    });
}

export function updateApiStatus(updateInfo) {
    return request({
        url: "/page/api/online",
        method: "put",
        data: updateInfo
    });
}

export function updateAppInfo(updateApp) {
    return request({
        url: "page/app/update/baseInfo",
        method: "put",
        data: updateApp
    });
}

export function updateAppInfoFor(updateApp) {
    return request({
        url: "page/app/update/baseInfoFor",
        method: "put",
        data: updateApp
    });
}

export function passWordmodify(updateApp) {
    return request({
        url: "white/platuser/forgetPassword",
        method: "post",
        data: updateApp
    });
}

// 签名方式
export function signature() {
    return request({
        url: "/apidoc/digest ",
        method: "get"
    });
}

// 错误码
export function errorCode() {
    return request({
        url: "/apidoc/error/code",
        method: "get"
    });
}

export function selectoffice(appInfo) {
    return request({
        url: "/officeenvironmentcontroller/selectoffice",
        method: "post",
        data: appInfo
    });
}
export function selectbanner(appInfo) {
    return request({
        url: "/officeenvironmentcontroller/selectbanner",
        method: "post",
        data: appInfo
    });
}

export function captcha(appInfo) {
    return request({
        url: "/nologinsystem/captcha",
        method: "get",
        data: appInfo
    });
}

export function menuqueryaddressid(appInfo) {
    return request({
        url: "/osmenucateory/menuqueryaddressid",
        method: "post",
        data: appInfo
    });
}
export function selectbyname(appInfo) {
    return request({
        url: "/city/selectbyname",
        method: "post",
        data: appInfo
    });
}

export function selecthotkeywords(appInfo) {
    return request({
        url: "/jobposition/selecthotkeywords",
        method: "post",
        data: appInfo
    });
}

export function selecthotjob(appInfo) {
    return request({
        url: "/jobposition/selecthotjob",
        method: "post",
        data: appInfo
    });
}

export function saveorupdatepersoninfo(appInfo) {
    return request({
        url: "/personinfo/saveorupdatepersoninfo",
        method: "post",
        data: appInfo
    });
}

export function selectbasicinfo(appInfo) {
    return request({
        url: "/personinfo/selectbasicinfo",
        method: "post",
        data: appInfo
    });
}
export function statusjob(appInfo) {
    return request({
        url: "/personinfo/statusjob",
        method: "post",
        data: appInfo
    });
}

export function selectstatusjob(appInfo) {
    return request({
        url: "/personinfo/selectstatusjob",
        method: "post",
        data: appInfo
    });
}

export function saveevaluation(appInfo) {
    return request({
        url: "/personinfo/saveevaluation",
        method: "post",
        data: appInfo
    });
}

export function selectevaluation(appInfo) {
    return request({
        url: "/personinfo/selectevaluation",
        method: "post",
        data: appInfo
    });
}

export function saveworkexperience(appInfo) {
    return request({
        url: "/personinfo/saveworkexperience",
        method: "post",
        data: appInfo
    });
}

export function selectworkexperience(appInfo) {
    return request({
        url: "/personinfo/selectworkexperience",
        method: "post",
        data: appInfo
    });
}

export function delectworkexperience(appInfo) {
    return request({
        url: "/personinfo/delectworkexperience",
        method: "post",
        data: appInfo
    });
}
export function saveeducateexperience(appInfo) {
    return request({
        url: "/personinfo/saveeducateexperience",
        method: "post",
        data: appInfo
    });
}

export function selecteducateexperience(appInfo) {
    return request({
        url: "/personinfo/selecteducateexperience",
        method: "post",
        data: appInfo
    });
}

export function delecteducateexperience(appInfo) {
    return request({
        url: "/personinfo/delecteducateexperience",
        method: "post",
        data: appInfo
    });
}
export function saveprojectexperience(appInfo) {
    return request({
        url: "/personinfo/saveprojectexperience",
        method: "post",
        data: appInfo
    });
}

export function selectprojectexperience(appInfo) {
    return request({
        url: "/personinfo/selectprojectexperience",
        method: "post",
        data: appInfo
    });
}

export function delectprojectexperience(appInfo) {
    return request({
        url: "/personinfo/delectprojectexperience",
        method: "post",
        data: appInfo
    });
}

export function selectmydelivery(appInfo) {
    return request({
        url: "/mydelivery/selectmydelivery",
        method: "post",
        data: appInfo
    });
}

export function querymycollection(appInfo) {
    return request({
        url: "/channelCustomer/userInfo/querymycollection",
        method: "post",
        data: appInfo
    });
}
export function addmycollection(appInfo) {
    return request({
        url: "channelCustomer/userInfo/addmycollection",
        method: "post",
        data: appInfo
    });
}

export function querybyonemycollection(appInfo) {
    return request({
        url: "/channelCustomer/userInfo/querybyonemycollection",
        method: "post",
        data: appInfo
    });
}

export function cancelmycollection(appInfo) {
    return request({
        url: "/channelCustomer/userInfo/cancelmycollection",
        method: "post",
        data: appInfo
    });
}

export function getunlimited(appInfo) {
    return request({
        url: "/jobposition/getunlimited",
        responseType: "arraybuffer",
        method: "post",
        data: appInfo
    });
}
